import { render } from "./PostRefPosts.vue?vue&type=template&id=3e908597&scoped=true"
import script from "./PostRefPosts.vue?vue&type=script&lang=js"
export * from "./PostRefPosts.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=3e908597&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e908597"]])

export default __exports__